import { Injectable } from '@angular/core';
import { ApiClientHelper } from '../helpers/api-client.helper';
import { AppConfig } from '../../shared/config/app-config';
import { Observable, catchError, retryWhen, switchMap, take, tap, throwError, timer } from 'rxjs';
@Injectable({
	providedIn: 'root'
})
export class ReferralPreRegistrationService {

	constructor(private apiClientHelper: ApiClientHelper,
		public config: AppConfig,) { }

	getPromotterName(code: string): Promise<any> {
		const url = `${this.config.MONIEPOINT_GAMIFICATION}/api/v1/promoter/first-name?referralCode=`+code;
		return this.apiClientHelper.getForPromise(url, false);
	}


	postReferralPreRegistrations(data): Observable<any> {
		let apiCallCount = 0;
		const maxRetries = this.config.REFERRAL_PRE_REGISTRATION_API_RETRY_COUNT;
		const url = `${this.config.MONIEPOINT_ONBOARDING}/api/v1/preregistrations`;
		return this.apiClientHelper.postForObservable(url, data, false)
		.pipe(
			catchError(error => {
			  return throwError(error);
			}),
			retryWhen(errors =>
                errors.pipe(
                    tap(() => {
                        if (apiCallCount === 0) {
                            this.openApplicationStore(data.referralCode);
                        }
                        apiCallCount += 1;
                    }),

                    switchMap(() => timer(this.config.REFERRAL_PRE_REGISTRATION_API_RETRY_INTERVAL)),
                    take(maxRetries)
                )
            )
		  );
	}

	openApplicationStore(code: string){
		let url = this.config.MONIEPOINT_APPLICATION_STORE_URL + code;
		window.open(url, '_blank');
	 }
}
